import axios from 'api/axios'
import { useEffect, useState } from 'react'

const useParseText = (text) => {
  const [response, setResponse] = useState([])
  const [error, setError] = useState()
  const [loading, setLoading] = useState(false)

  const fetchData = () => {
    setLoading(true)
    axios
      .post(`/parse/`, { text: text })
      .then((request_response) => {
        setResponse(request_response.data)
        setError(null)
      })
      .catch((request_error) => setError(request_error))
      .finally(() => setLoading(false))
  }

  useEffect(() => {
    fetchData()
  }, [text])

  return { response, error, loading }
}

export default useParseText
